module.exports = __webpack_public_path__ + "img/ic_find_jobs.041276c0.svg";